import React, { useState, useEffect, useRef } from "react";
import Scrolly from "./Scrolly";
import "../style/ScrollyVideo.scss";
// import { useInViewport } from "react-in-viewport";

const ScrollyVideo = (props) => {
  const { steps, width, height } = props;
  const videoBoxEls = useRef([]);
  const videoEls = useRef([]);
  const [wide, setWide] = useState(true);

  // console.log(width + ", " + height);

  const [progress, setProgress] = useState({
    overallPct: 0,
    currentStep: 0,
    currentStepPct: 0,
  });

  useEffect(() => {
    setWide(width > height ? true : false);
  }, [width, height]);

  // useEffect(() => {
  //   if (videoEls.current) {
  //     firstVideoRef.current = videoEls.current[0];
  //   }
  // }, [videoEls.current]);

  // useEffect(() => {
  //   if (firstVideoRef.current.paused) {
  //     updateVideo(0);
  //   }
  // }, [inViewport]);

  useEffect(() => {
    updateVideo(progress.currentStep);
  }, [progress.currentStep]);

  const updateVideo = (currentStep) => {
    steps.map((d, i) => {
      if (i === currentStep) {
        videoBoxEls.current[i].style.zIndex = -1;
        videoBoxEls.current[i].style.opacity = 1;
        videoEls.current[i].currentTime = 0;

        setTimeout(function () {
          if (steps[currentStep].type === "video") {
            videoEls.current[i].play();
          }
        }, 150);
      } else {
        videoBoxEls.current[i].style.zIndex = -10;
        videoBoxEls.current[i].style.opacity = 0;
        if (steps[i].type === "video") {
          videoEls.current[i].pause();
        }
      }
    });
  };

  const handleVideoEnd = () => {
    setTimeout(function () {
      if (steps[progress.currentStep].type === "video") {
        videoEls.current[progress.currentStep].play();
      }
    }, 830);
  };

  return (
    <Scrolly onProgressHandler={setProgress} steps={steps}>
      <div>
        {steps.map((thisData, stepIndex) => (
          <div
            className="scrolly-video-box"
            style={{ zIndex: stepIndex === 0 ? -1 : -10 }}
            ref={(el) => (videoBoxEls.current[stepIndex] = el)}
            key={"scrolly-video-player" + stepIndex}
          >
            <div className={`scrolly-video-flex`}>
              {thisData.type === "video" ? (
                wide ? (
                  <video
                    controls={false}
                    onEnded={handleVideoEnd}
                    className={wide ? `player` : `player-fill`}
                    autoPlay={false}
                    playsInline
                    muted
                    key={"body-video" + stepIndex}
                    id={"body-video" + stepIndex}
                    ref={(el) => (videoEls.current[stepIndex] = el)}
                    src={process.env.PUBLIC_URL + "/" + thisData.url}
                    type="video/mp4"
                  />
                ) : (
                  <video
                    controls={false}
                    onEnded={handleVideoEnd}
                    className={wide ? `player` : `player-fill`}
                    autoPlay={false}
                    playsInline
                    muted
                    key={"body-video" + stepIndex}
                    id={"body-video" + stepIndex}
                    ref={(el) => (videoEls.current[stepIndex] = el)}
                    src={process.env.PUBLIC_URL + "/" + thisData.url_m}
                    type="video/mp4"
                  />
                )
              ) : (
                <img
                  ref={(el) => (videoEls.current[stepIndex] = el)}
                  className={
                    wide ? `scrolly-photo` : `.scrolly-video-photo-mobile`
                  }
                  src={
                    wide
                      ? process.env.PUBLIC_URL + "/" + thisData.url
                      : process.env.PUBLIC_URL + "/" + thisData.url_m
                  }
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </Scrolly>
  );
};

export default ScrollyVideo;
